module.exports = __webpack_public_path__ + "img/IMG_1454_L_WoodMatted_MockedUp.a6817494.jpg";